import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import { FaRegDotCircle } from "react-icons/fa";
import banner from "../../../assets/images/Custom-Packing/compound_pharmacy_web_banner.jpg"
import img from "../../../assets/images/Custom-Packing/21_grande_4625e49a-f8a9-4824-acfc-a5bafb2e5680.png"
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";
// import Aos from 'aos';
// import 'aos/dist/aos.css';
// import { useEffect } from "react";

const CustomPacking = () => {

  // useEffect(() => {
  //   Aos.init({duration: 2000});
  // }, []);
  
  return (
    <CustomPackingContainer >
      <TopServiceBanner title="Custom Packing" banner={ banner} />
      <CustomPackingContainerInner>
        <CustomPackingTitle>
          CUSTOMIZED TO FIT YOUR SPECIFIC NEEDS
        </CustomPackingTitle>
        <CustomPackingSubTitle>
          We understand that having a quality product is essential in the
          pharmaceutical industry, therefore, we assure you that your custom
          pharmaceutical packaging boxes are made to the most rigorous quality
          standards with strict adherence to operating procedures that will meet
          or exceed your stringent requirements.
          <br />
          <br />
          As every patient has different needs, so we provide both pouch and
          tray based packaging systems. Our custom pharmaceutical packaging
          boxes project a look of cleanliness and reliability to complement the
          products they contain.
        </CustomPackingSubTitle>
        <CustomPackingTitle>HOW CUSTOM PACKS HELP YOU?</CustomPackingTitle>
        <CustomPackingMiddle>
          <CustomPackingMiddleLeft>
            <CustomPackingUl>
              <CustomPackingLi>
                <FaRegDotCircle />
                A good packaging always give assurance of patient safety.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle /> 
                Uniformity of the products in different batches and in different production lots.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                It must maintain the physical quality of all dosage and protect against all damage.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                Packaging maintain the characteristics properties of the pharmaceutical products.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                A ideal packaging should be able to hold the product without loss of leakage or spoilage.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                A ideal packaging should not absorb or  adsorb any material containing.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                The closure should be compatible with pharmaceutical product.
              </CustomPackingLi>
              <CustomPackingLi>
                <FaRegDotCircle />
                A ideal packaging should be able to reduce the risk of toxicity
              </CustomPackingLi>
            </CustomPackingUl>
          </CustomPackingMiddleLeft>
          <CustomPackingMiddleRight>
            <CustomPackingMiddleImage
              src={img}
              alt="Custom Packing"
            />
          </CustomPackingMiddleRight>
        </CustomPackingMiddle>
      </CustomPackingContainerInner>
      <BottomServiceBanner />
      <BottomBanner/>
    </CustomPackingContainer>
  );
};

export default CustomPacking;

const CustomPackingContainer = styled.div`
`;

const CustomPackingContainerInner = styled.div``;

const CustomPackingTitle = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;
  letter-spacing: 1.5px;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 1000px) {
    font-size: 30px;
  }
  @media (max-width: 600px) {
    font-size: 28px;
  }
  @media (max-width: 460px) {
    font-size: 22px;
  }
`;

const CustomPackingSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  opacity: 0.7;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const CustomPackingMiddle = styled.div`
  display: flex;
  justify-content: space-around;

  @media (max-width: 1000px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const CustomPackingMiddleLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const CustomPackingMiddleRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomPackingUl = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 2rem 0 2rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }

`;
const CustomPackingLi = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const CustomPackingMiddleImage = styled.img`
  width: 90%;
  height: 100%;

  @media (max-width: 1000px) {
    width: 50%;
    height: 50%;
  }
`;
